module.exports = __webpack_public_path__ + "static/media/pl410.168a1c92.png";